<div class="gameMode">

  <wab-timer [wabgData]="$safeNavigationMigration(gWhackConfig?.gameData)" [imagePath]="gameImageAssets" (onEnd)="onGameEnd()"></wab-timer>

  <span class="wab-logo">
    <img [src]="getImg('logoTwo')" alt="" srcset="">
  </span>

  <div class="playArea" ondragstart="return false;">
    <div class="pitGrid noSelect">
      @for (item of pitsCount; track item) {
        <div class="pit noSelect">
          <span class="pitClick" (click)="onHit(item)"></span>
          <span class="wab_pit sprite">
            <img [src]="getImg('pit')" alt="" srcset="">
          </span>
        </div>
      }
    </div>

    <div class="anim">
      <div class="animArea">
        <img class="wab-wabbitAnim" [src]="getImg('rabbit')" (click)="onRabbitHit()">
        <div class="disbaleHit"></div>
      </div>

      <div class="smokeArea">
        <img class="wab-smokeAnim" [src]="getImg('smoke')">
      </div>

      <div class="oopsArea">
        <img class="wab-oopsAnim" [src]="getImg('miss')">
      </div>

      <div class="hitArea">
        <img class="wab-hitAnim" [src]="getImg('hit')">
      </div>

      <div class="hammerArea">
        <img class="wab-hammerAnim" [src]="getImg('hammer')">
      </div>

      <div class="scoreArea">
        <div class="scoreTxt">{{ "+" + hitPoints}}</div>
      </div>
    </div>
  </div>

  <div class="wab-play wab-btnBg" [ngStyle]="{'color': introTxtColor}">
    <img [src]="getImg('ctaBg')" alt="" srcset="">

    <div class="wab-txt-play">
      <span>{{getTranslation('wab_score_in_play')}}<span class="txtBold">{{score}}</span></span>
      <!-- <ng-container [ngSwitch]="currentGameType">
      <ng-container *ngSwitchCase="GameType.POINTS">
        <span *ngIf="isPointType">{{getTranslation('wab_reward_in_play')}}<span class="txtBold">
          <span *ngIf="getCurrencySymbol(bonusType)" class="txtBold">{{reward | wabCurrency}}</span>
          <span *ngIf="getCurrencySymbol(bonusType)" class="txtBold">{{reward}}</span>
          <span *ngIf="!getCurrencySymbol(bonusType)"
          class="txtBold">{{reward}}</span>{{getTranslation(bonusType)}}</span>
        </span>
      </ng-container>
      <ng-container *ngSwitchCase="GameType.TICKETS">
        <span *ngIf="!isPointType">{{getTranslation('wab_prize_in_play')}}<span class="txtBold">{{prize |
        wabCurrency}}</span></span>
        <span *ngIf="!isPointType">{{getTranslation('wab_prize_in_play')}}<span
        class="txtBold">{{prize}}</span></span>
        <span *ngIf="!isPointType">{{getTranslation('wab_number_tickets_in_play')}}<span
        class="txtBold">{{ticketsCount}}</span></span>
      </ng-container>
    </ng-container> -->
  </div>
</div>
</div>